import styled from 'styled-components';

export const Name = styled.div`
  line-height: 1;
`;
